import { render, staticRenderFns } from "./determination.vue?vue&type=template&id=bbf6d8e8&"
import script from "./determination.vue?vue&type=script&lang=js&"
export * from "./determination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports